export const HANDMADES = "handmades";
export const JUDE = "blog";
